import { Box } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { getDate, getMonth } from "date-fns"

function isAprilFools(): boolean {
  const today = new Date()
  return getMonth(today) === 3 && getDate(today) === 1
}

function isChristmas(): boolean {
  const today = new Date()
  return getMonth(today) === 11 && getDate(today) >= 23
}

export default function SatellietLogo({
  width,
  height,
  isStaff = false,
  inverted = false,
  sx,
}: {
  width?: number
  height?: number
  inverted?: boolean
  isStaff?: boolean
  sx?: object
}) {
  const theme = useTheme()
  const colorInverted = inverted ? theme.palette.common.white : theme.palette.text.primary

  if (isAprilFools() && isStaff) {
    return <WordArt width={width} height={height} inverted={inverted} sx={sx} />
  }

  if (isChristmas() && isStaff) {
    return <Santa width={width} height={height} inverted={inverted} sx={sx} />
  }

  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        width: width,
        height: height,
        fill: colorInverted,
        ...sx,
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 383.4 119.3" width="auto" height="100%">
        <path d="M53 32.1c-11.3-2.9-13.5-3.4-13.5-6.8 0-3.8 3.7-5.1 6.8-5.1 4.7 0 8.6 1.4 8.9 6.8h9.6c0-10.4-8.7-14.6-18.1-14.6-8.2 0-16.9 4.4-16.9 13.7 0 8.5 6.8 11.1 13.5 12.8 6.6 1.8 13.4 2.6 13.4 7.5 0 4.6-5.3 5.6-8.8 5.6-5.3 0-10-2.3-10-8.3h-9.6c-.1 11.1 9.2 16.1 19.2 16.1 12.3 0 18.8-6.2 18.8-14.5C66.4 35 56.3 33 53 32.1"></path>
        <path d="M321.2 21.9L332.3 21.9 332.3 58.7 342.3 58.7 342.3 21.9 353.4 21.9 353.4 13.5 321.2 13.5z"></path>
        <path d="M365.4 16.5c0 .2 0 .4-.1.5l-.3.3c-.1.1-.3.1-.5.1H363v-1.8h1.7c.2 0 .3.1.4.1l.3.3v.5m.5 1.2c.3-.2.4-.6.4-1.1 0-.6-.2-1-.5-1.2-.3-.3-.8-.4-1.5-.4h-2.2v5.7h.9v-2.5h.9l1.6 2.5h1l-1.6-2.5c.3-.1.7-.3 1-.5"></path>
        <path d="M368.1 17.8c0 .6-.1 1.2-.3 1.7s-.5 1-.8 1.3c-.4.4-.8.7-1.3.9s-1 .3-1.6.3-1.1-.1-1.6-.3-.9-.5-1.3-.9-.6-.8-.9-1.3c-.2-.5-.3-1.1-.3-1.7s.1-1.1.3-1.6.5-.9.9-1.3.8-.7 1.3-.9 1-.3 1.6-.3 1.1.1 1.6.3.9.5 1.3.9.6.8.8 1.3c.2.4.3 1 .3 1.6m.8 0c0-.7-.1-1.3-.4-1.9s-.6-1.1-1.1-1.5-1-.8-1.6-1-1.2-.4-1.9-.4-1.3.1-1.9.4-1.1.6-1.6 1c-.4.4-.8 1-1.1 1.5-.3.6-.4 1.2-.4 1.9s.1 1.4.4 2 .6 1.1 1.1 1.6c.4.4 1 .8 1.6 1s1.2.4 1.9.4 1.3-.1 1.9-.4c.6-.2 1.1-.6 1.6-1 .4-.4.8-1 1.1-1.6.3-.7.4-1.3.4-2"></path>
        <path d="M292.4 39.3L314.3 39.3 314.3 31.6 292.4 31.6 292.4 21.9 316.2 21.9 316.2 13.5 282.5 13.5 282.5 58.7 316.8 58.7 316.8 50.3 292.4 50.3z"></path>
        <path d="M236.1 13.5L226.1 13.5 226.1 58.7 253.2 58.7 253.2 50.3 236.1 50.3z"></path>
        <path d="M260.7 13.5H270.59999999999997V58.7H260.7z"></path>
        <path d="M30 75H353.4V77.3H30z"></path>
        <path d="M110 21.9L121.1 21.9 121.1 58.7 131.1 58.7 131.1 21.9 142.2 21.9 142.2 13.5 110 13.5z"></path>
        <path d="M158.6 39.3L180.5 39.3 180.5 31.6 158.6 31.6 158.6 21.9 182.4 21.9 182.4 13.5 148.7 13.5 148.7 58.7 182.9 58.7 182.9 50.3 158.6 50.3z"></path>
        <path d="M96.1 41.2H84.4l5.9-16.6h.1l5.7 16.6zm16.3 17.5L95.5 13.5H85.3L68.2 58.7h10.1l3.5-10.1h16.9l3.4 10.1h10.3z"></path>
        <path d="M202.7 13.5L192.8 13.5 192.8 58.7 219.9 58.7 219.9 50.3 202.7 50.3z"></path>
        <path d="M31.6 90.2v6.3c.3-.7.7-1.2 1.4-1.7.7-.4 1.4-.6 2.2-.6s1.4.1 2 .3c.5.2 1 .5 1.3.9s.5.8.7 1.4c.1.5.2 1.1.2 1.8v7.3H38v-7c0-.5 0-.9-.1-1.3s-.2-.8-.5-1.1c-.2-.3-.5-.5-.9-.7s-.8-.3-1.4-.3-1 .1-1.5.3c-.4.2-.8.5-1.1.8s-.5.8-.7 1.2c-.2.5-.3 1-.3 1.5v6.6h-1.4V90.2h1.5zM56.5 94.7c.7.3 1.2.8 1.7 1.3s.8 1.2 1 1.9.3 1.5.3 2.3-.1 1.6-.3 2.3-.6 1.4-1 1.9c-.5.5-1 1-1.7 1.3s-1.4.5-2.3.5-1.6-.2-2.3-.5-1.2-.7-1.7-1.3c-.5-.5-.8-1.2-1-1.9s-.3-1.5-.3-2.3.1-1.6.3-2.3.6-1.4 1-1.9c.5-.5 1-1 1.7-1.3s1.4-.5 2.3-.5 1.6.2 2.3.5zm-4 1.1c-.5.3-.9.6-1.2 1.1s-.6 1-.7 1.5-.3 1.2-.3 1.8.1 1.2.3 1.8.4 1.1.7 1.5c.3.5.7.8 1.2 1.1s1.1.4 1.7.4c.7 0 1.2-.1 1.7-.4s.9-.6 1.2-1.1.6-1 .7-1.5c.2-.6.3-1.2.3-1.8s-.1-1.2-.3-1.8-.4-1.1-.7-1.5c-.3-.5-.7-.8-1.2-1.1s-1.1-.4-1.7-.4-1.2.1-1.7.4zM75.5 96.7c-.2-.3-.4-.6-.6-.8-.3-.2-.6-.4-.9-.4-.4-.1-.7-.1-1.1-.1-.3 0-.6 0-.9.1l-.9.3c-.3.2-.5.4-.6.6-.2.2-.2.6-.2.9s.1.6.2.8c.2.2.3.4.6.5.2.1.5.3.8.4s.5.2.8.2l1.8.4 1.2.3c.4.2.7.4 1 .6s.5.6.7.9c.2.4.3.8.3 1.3 0 .6-.1 1.1-.4 1.6-.3.4-.6.8-1.1 1.1-.4.3-.9.5-1.5.6-.5.1-1.1.2-1.6.2-1.3 0-2.4-.3-3.2-.9s-1.3-1.6-1.4-3h1.4c.1.9.4 1.6 1 2.1s1.4.7 2.3.7c.3 0 .7 0 1-.1.4-.1.7-.2 1-.4s.6-.4.8-.7.3-.6.3-1c0-.3-.1-.6-.2-.8s-.3-.4-.6-.6c-.2-.2-.5-.3-.8-.4l-.9-.3-1.8-.4c-.5-.1-.9-.3-1.2-.4-.4-.2-.7-.3-1-.6-.3-.2-.5-.5-.7-.8s-.2-.7-.2-1.2c0-.6.1-1.1.4-1.5s.6-.7 1-1 .9-.4 1.4-.5 1-.2 1.5-.2c.6 0 1.1.1 1.6.2s.9.4 1.3.7.7.7.9 1.1c.2.5.3 1 .4 1.6H76c-.2-.4-.3-.8-.5-1.1zM88.3 94.5v2.1c.3-.8.8-1.4 1.6-1.8.7-.4 1.5-.6 2.5-.6.9 0 1.6.2 2.2.5s1.2.8 1.6 1.3.7 1.2.9 1.9.3 1.5.3 2.3-.1 1.6-.3 2.3-.5 1.4-.9 1.9-1 1-1.6 1.3-1.4.5-2.2.5c-.4 0-.8-.1-1.2-.2s-.8-.3-1.1-.5-.7-.5-.9-.8c-.3-.3-.5-.7-.6-1.1v6.3H87V94.5h1.3zm7.5 3.9c-.1-.6-.4-1.1-.7-1.5-.3-.5-.7-.8-1.1-1.1-.5-.3-1-.4-1.7-.4-.8 0-1.4.1-1.9.4s-.9.6-1.2 1.1c-.3.4-.5.9-.6 1.5s-.2 1.2-.2 1.8.1 1.2.2 1.7c.1.6.4 1.1.7 1.5.3.5.7.8 1.2 1.1s1.1.4 1.8.4 1.2-.1 1.7-.4.8-.7 1.1-1.1c.3-.5.5-1 .7-1.5.1-.6.2-1.2.2-1.7 0-.6 0-1.2-.2-1.8zM108.4 90.2v2.2H107v-2.2h1.4zm0 4.3v11.3H107V94.5h1.4zM123 94.5v1.2h-2.3v7.6c0 .5.1.8.2 1.1s.4.4.9.4c.4 0 .8 0 1.2-.1v1.2h-1.2c-.9 0-1.6-.2-1.9-.5-.4-.4-.5-1-.5-2v-7.7h-2v-1.2h2v-3.4h1.4v3.4h2.2zM132.7 96.3c.2-.5.6-.9 1-1.2s.9-.5 1.4-.7c.5-.1 1.1-.2 1.8-.2.5 0 1 0 1.5.1s.9.3 1.3.5c.4.3.7.6 1 1.1.2.5.4 1.1.4 1.8v6c0 .6.3.8.8.8.2 0 .3 0 .4-.1v1.2c-.2 0-.3.1-.4.1h-.5c-.3 0-.6 0-.8-.1s-.4-.2-.5-.4-.2-.4-.2-.6-.1-.5-.1-.8c-.2.4-.5.7-.8 1s-.5.5-.9.7c-.3.2-.7.3-1.1.4s-.9.2-1.4.2-1-.1-1.5-.2-.9-.3-1.2-.6-.6-.6-.8-1-.3-.9-.3-1.5c0-.8.2-1.4.5-1.8s.8-.8 1.4-1 1.2-.4 1.9-.5 1.5-.2 2.2-.3c.3 0 .5-.1.8-.1s.4-.1.5-.2.3-.3.3-.4c.1-.2.1-.4.1-.7 0-.5-.1-.8-.2-1.1-.2-.3-.4-.5-.6-.7-.3-.2-.6-.3-.9-.4-.4-.1-.7-.1-1.1-.1-.9 0-1.6.2-2.1.6-.6.4-.8 1.1-.9 2h-1.4c0-.8.2-1.3.4-1.8zm6.9 3.4c-.1.2-.3.3-.5.3-.2.1-.5.1-.7.2l-1.8.3c-.6.1-1.2.2-1.7.4s-.9.4-1.3.7c-.3.3-.5.7-.5 1.3 0 .3.1.7.2.9.1.3.3.5.6.7.2.2.5.3.8.4s.6.2.9.2c.5 0 1-.1 1.5-.2.5-.2.9-.4 1.3-.7s.6-.7.9-1.1c.2-.4.3-.9.3-1.5v-1.9zM152.6 90.2v15.6h-1.4V90.2h1.4zM164.1 90.2v2.2h-1.4v-2.2h1.4zm0 4.3v11.3h-1.4V94.5h1.4zM178.6 94.5v1.2h-2.3v7.6c0 .5.1.8.2 1.1s.4.4.9.4c.4 0 .8 0 1.2-.1v1.2h-1.2c-.9 0-1.6-.2-1.9-.5-.4-.4-.5-1-.5-2v-7.7h-2v-1.2h2v-3.4h1.4v3.4h2.2zM188.3 94.5l3.7 9.6 3.5-9.6h1.4l-4.9 13c-.2.5-.4.9-.6 1.2s-.4.6-.6.7c-.2.2-.5.3-.7.4-.3.1-.6.1-1.1.1h-.6c-.2 0-.3 0-.4-.1v-1.2c.2 0 .3.1.5.1h.5c.3 0 .6 0 .8-.1s.4-.2.5-.4.3-.3.4-.6c.1-.2.2-.5.3-.7l.5-1.3-4.5-11.2h1.3zM221.3 95.7v10.1h-1.4V95.7H218v-1.2h1.9v-1c0-.5 0-.9.1-1.3s.2-.8.4-1.1.5-.5.8-.7c.4-.2.8-.2 1.4-.2h.6c.2 0 .4 0 .6.1v1.2c-.2 0-.4-.1-.5-.1h-.5c-.4 0-.7.1-.9.2s-.4.3-.4.5c-.1.2-.1.4-.2.7v1.9h2.2v1.2h-2.2zM240.1 105.8v-2c-.4.8-.9 1.3-1.6 1.7s-1.5.6-2.3.6c-.7 0-1.3-.1-1.8-.3s-.9-.5-1.2-.8-.5-.8-.7-1.3c-.1-.5-.2-1.1-.2-1.8v-7.3h1.4v7.4c0 1 .3 1.8.7 2.3s1.2.8 2.3.8c.6 0 1.1-.1 1.5-.4s.8-.6 1.1-1 .5-.9.6-1.5c.1-.5.2-1.1.2-1.7v-5.9h1.4v11.3h-1.4zM252.7 94.5v2.6c.4-.9.9-1.6 1.6-2.1s1.6-.7 2.6-.7v1.4c-.6 0-1.2.1-1.7.3s-1 .5-1.3.8c-.4.4-.7.8-.9 1.3s-.3 1.1-.3 1.7v6h-1.4V94.5h1.4zM267.5 94.5v1.9c.3-.7.7-1.2 1.4-1.7.7-.4 1.4-.6 2.2-.6s1.4.1 2 .3c.5.2 1 .5 1.3.9s.5.8.7 1.4c.1.5.2 1.1.2 1.8v7.3h-1.4v-7c0-.5 0-.9-.1-1.3s-.2-.8-.5-1.1c-.2-.3-.5-.5-.9-.7s-.8-.3-1.4-.3-1 .1-1.5.3c-.4.2-.8.5-1.1.8s-.5.8-.7 1.2c-.2.5-.3 1-.3 1.5v6.6H266V94.5h1.5zM286.8 90.2v2.2h-1.4v-2.2h1.4zm0 4.3v11.3h-1.4V94.5h1.4zM301.3 94.5v1.2H299v7.6c0 .5.1.8.2 1.1s.4.4.9.4c.4 0 .8 0 1.2-.1v1.2h-1.2c-.9 0-1.6-.2-1.9-.5-.4-.4-.5-1-.5-2v-7.7h-2v-1.2h2v-3.4h1.4v3.4h2.2zM318.6 105.8v-2c-.4.8-.9 1.3-1.6 1.7s-1.5.6-2.3.6c-.7 0-1.3-.1-1.8-.3s-.9-.5-1.2-.8c-.3-.4-.5-.8-.7-1.3-.1-.5-.2-1.1-.2-1.8v-7.3h1.4v7.4c0 1 .3 1.8.7 2.3s1.2.8 2.3.8c.6 0 1.1-.1 1.5-.4s.8-.6 1.1-1 .5-.9.6-1.5c.1-.5.2-1.1.2-1.7v-5.9h1.4v11.3h-1.4zM331.2 94.5v2.6c.4-.9.9-1.6 1.6-2.1s1.6-.7 2.6-.7v1.4c-.6 0-1.2.1-1.7.3s-1 .5-1.3.8c-.4.4-.7.8-.9 1.3s-.3 1.1-.3 1.7v6H330V94.5h1.2zM344.9 102.1c.1.5.4 1 .7 1.4s.7.8 1.2 1.1 1 .4 1.7.4c1 0 1.8-.3 2.4-.8s1-1.2 1.2-2.1h1.4c-.3 1.3-.8 2.3-1.6 3s-1.9 1.1-3.3 1.1c-.9 0-1.7-.2-2.3-.5s-1.2-.7-1.6-1.3c-.4-.5-.7-1.2-.9-1.9s-.3-1.5-.3-2.3c0-.7.1-1.5.3-2.2s.5-1.4.9-1.9c.4-.6.9-1 1.6-1.4.6-.3 1.4-.5 2.3-.5s1.7.2 2.3.5 1.2.8 1.6 1.4.7 1.3.9 2c.2.8.2 1.5.2 2.3h-8.7c-.2.6-.1 1.2 0 1.7zm6.8-4.2c-.2-.5-.4-.9-.7-1.3s-.7-.7-1.1-.9-.9-.3-1.5-.3-1.1.1-1.5.3-.8.5-1.1.9-.6.8-.7 1.3c-.2.5-.3 1-.4 1.5h7.3c0-.5-.1-1-.3-1.5z"></path>
      </svg>
    </Box>
  )
}

function WordArt({
  width,
  height,
  inverted = false,
  sx,
}: {
  width?: number
  height?: number
  inverted?: boolean
  sx?: object
}) {
  const theme = useTheme()

  const colorInverted = inverted ? theme.palette.common.white : theme.palette.text.primary

  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        width: width,
        height: height,
        fill: colorInverted,
        ...sx,
      }}
    >
      <Box
        component="img"
        src="https://ams3.digitaloceanspaces.com/satelliet-static/assets/logos/Logo_Satelliet_wordart.png"
        sx={{ maxHeight: "100%", maxWidth: "100%" }}
      />
    </Box>
  )
}

function Santa({
  width,
  height,
  inverted = false,
  sx,
}: {
  width?: number
  height?: number
  inverted?: boolean
  sx?: object
}) {
  const theme = useTheme()

  const colorInverted = inverted ? theme.palette.common.white : theme.palette.text.primary

  const newHeight = typeof height === "number" ? height + 5 : height

  const imageUrl = inverted
    ? "https://ams3.digitaloceanspaces.com/satelliet-static/assets/logos/Logo_Satelliet_wit_santa.png"
    : "https://ams3.digitaloceanspaces.com/satelliet-static/assets/logos/Logo_Satelliet_zwart_santa.png"

  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        width: width,
        height: newHeight,
        fill: colorInverted,
        ...sx,
      }}
    >
      <Box component="img" src={imageUrl} sx={{ maxHeight: "100%", maxWidth: "100%" }} />
    </Box>
  )
}
